/* Home campaign content: reads the same Supabase table the app's home screen
   uses (home_campaign_images, public read) and hydrates the story discs with
   the current weekly images. Layout paints instantly from Liquid; images pop
   in when the fetch lands, exactly like the app's remote-content model. */

(function () {
  function config() {
    var el = document.querySelector('[data-gettmi-supabase]');
    return el ? { url: el.dataset.supabaseUrl, key: el.dataset.supabaseKey } : null;
  }

  function publicUrl(cfg, row, width, quality, height) {
    var version = (row.metadata && row.metadata.asset_version) || row.updated_at || row.id || '';
    var path = String(row.image_path || '').split('/').map(encodeURIComponent).join('/');
    var params = [
      'width=' + encodeURIComponent(width || 1080),
      'quality=' + encodeURIComponent(quality || 72),
      'resize=cover'
    ];
    if (height) params.splice(1, 0, 'height=' + encodeURIComponent(height));
    if (version) params.push('v=' + encodeURIComponent(version));
    return (
      cfg.url + '/storage/v1/render/image/public/' + encodeURIComponent(row.bucket) + '/' + path +
      '?' + params.join('&')
    );
  }

  function mobileContentWidth() {
    return Math.min(Math.max(window.innerWidth || document.documentElement.clientWidth || 390, 320), 720);
  }

  function sourceHeightForTarget(sourceWidth, targetWidth, targetHeight) {
    return Math.max(1, Math.round(sourceWidth * targetHeight / Math.max(1, targetWidth)));
  }

  function localPath(path) {
    var localeRoot =
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root ||
      '/';
    return String(localeRoot).replace(/\/?$/, '/') + String(path || '').replace(/^\/+/, '');
  }

  function storyLink(row) {
    var path = String(row && row.link_path || '');
    if (!path) return null;
    if (path.indexOf('native://') !== 0) return path;
    var nativeTarget = path.slice('native://'.length).replace(/^\/+|\/+$/g, '').toLowerCase();
    var title = String(row && row.title || '').trim().toLowerCase();
    if (nativeTarget === 'brands' || nativeTarget === 'brand-directory' || title === 'brands') {
      return localPath('pages/designers-a-z');
    }
    return null;
  }

  function hydrateStories(cfg, rows) {
    var mount = document.querySelector('[data-gettmi-stories]');
    if (!mount) return;
    var stories = rows
      .filter(function (r) { return r.surface === 'stories' && r.bucket && r.image_path; })
      .filter(function (r) { return Boolean(storyLink(r)); })
      .sort(function (a, b) { return (a.sort_order || 0) - (b.sort_order || 0); });
    if (!stories.length) return;

    mount.innerHTML = stories.map(function (row) {
      return (
        '<a class="gettmi-story" href="' + encodeURI(storyLink(row)) + '">' +
          '<span class="gettmi-story__ring">' +
            '<img src="' + publicUrl(cfg, row, 192, 68, 192) + '" alt="" loading="lazy" width="64" height="64">' +
          '</span>' +
          '<span class="gettmi-story__label">' + String(row.title || '').replace(/[<>&"]/g, '') + '</span>' +
        '</a>'
      );
    }).join('');
  }

  function surfaceRows(rows, surface) {
    return rows
      .filter(function (r) { return r.surface === surface && r.bucket && r.image_path; })
      .sort(function (a, b) { return (a.sort_order || 0) - (b.sort_order || 0); });
  }

  /* The app's brand tiles link to its native vendor route; the web equivalent
     is Shopify's built-in vendor collection. */
  function webLink(path) {
    if (!path) return null;
    if (path.indexOf('native://') === 0) return null;
    return path.replace('/collections/vendors?vendor=', '/collections/vendors?q=');
  }

  function hydrateTiles(cfg, rows, surface, mountSelector, tileClass, buildTile) {
    var mount = document.querySelector(mountSelector);
    if (!mount) return;
    var items = surfaceRows(rows, surface);
    if (!items.length) return;
    mount.innerHTML = items.map(function (row) { return buildTile(row); }).join('');
  }

  function esc(value) {
    return String(value == null ? '' : value).replace(/[<>&"]/g, '');
  }

  function hydrateEditorial(cfg, rows) {
    var contentWidth = mobileContentWidth();
    var redCarpetTileWidth = Math.max(1, (contentWidth - 12) / 3);
    hydrateTiles(cfg, rows, 'brand-tiles', '[data-gettmi-brand-tiles]', 'gettmi-rtrc-tile', function (row) {
      var link = webLink(row.link_path) || '#';
      return (
        '<a class="gettmi-rtrc-tile" href="' + encodeURI(link) + '">' +
          '<span class="gettmi-rtrc-tile__title">' + esc(row.title) + '</span>' +
          '<span class="gettmi-rtrc-tile__image"><img src="' +
            publicUrl(cfg, row, 480, 70, sourceHeightForTarget(480, redCarpetTileWidth, 208)) +
            '" alt="" loading="lazy"></span>' +
        '</a>'
      );
    });

    hydrateTiles(cfg, rows, 'style-discs', '[data-gettmi-style-discs]', 'gettmi-style-disc', function (row) {
      var ring = document.querySelector('.gettmi-style-disc__ring');
      var ringSrc = ring ? ring.getAttribute('src') : '';
      return (
        '<button class="gettmi-style-disc" type="button" data-gettmi-nav-notice="' +
          'Shop the full look, styled by the girls who do it best. In the app.' +
        '" data-gettmi-app-gate="shop_styles" data-gettmi-app-gate-placement="home_shop_styles">' +
          '<span class="gettmi-style-disc__bullseye">' +
            (ringSrc ? '<img class="gettmi-style-disc__ring" src="' + ringSrc + '" alt="" width="128" height="128">' : '') +
            '<span class="gettmi-style-disc__inner">' +
              '<span class="gettmi-style-disc__image"><img src="' + publicUrl(cfg, row, 480, 70, 480) + '" alt="" loading="lazy"></span>' +
            '</span>' +
          '</span>' +
          '<span class="gettmi-style-disc__label">' + esc(row.title) + '</span>' +
        '</button>'
      );
    });
    hydrateStyleCreators(rows);

    var trends = surfaceRows(rows, 'hot-trends')[0];
    var trendsMount = document.querySelector('[data-gettmi-hot-trends]');
    if (trends && trendsMount) {
      var trendsLink = webLink(trends.link_path);
      if (trendsLink) trendsMount.setAttribute('href', encodeURI(trendsLink));
      var trendsImage = document.querySelector('[data-gettmi-hot-trends-image]');
      if (trendsImage) {
        trendsImage.classList.remove('gettmi-placeholder');
        trendsImage.innerHTML = '<img src="' + publicUrl(cfg, trends, 1080, 72, 1317) + '" alt="' + esc(trends.title) + '" loading="lazy">';
      }
      var trendsTitle = document.querySelector('[data-gettmi-trends-title]');
      if (trendsTitle && trends.title) trendsTitle.textContent = trends.title;

      /* The row's metadata carries the editorial itself (intro, the eight
         trends, creator credit), same as the app's buildSurfaceFeature. */
      var meta = trends.metadata || {};
      var intro = document.querySelector('[data-gettmi-trends-intro]');
      if (intro && meta.intro) intro.textContent = meta.intro;
      var list = document.querySelector('[data-gettmi-trends-list]');
      if (list && Array.isArray(meta.trends) && meta.trends.length) {
        list.innerHTML = meta.trends.map(function (name) {
          return '<li>' + esc(name) + '</li>';
        }).join('');
      }
      var credit = document.querySelector('[data-gettmi-trends-credit]');
      if (credit && meta.creator_handle) {
        credit.textContent = meta.creator_handle;
        if (meta.creator_url) credit.setAttribute('href', meta.creator_url);
      }
    }

    hydrateTmi(cfg, rows);
  }

  function instagramCreator(row) {
    var meta = row.metadata || {};
    var username = String(meta.creator_handle || '').trim().replace(/^@+/, '').toLowerCase();
    if (!/^[a-z0-9_](?:[a-z0-9._]{0,28}[a-z0-9_])?$/.test(username) || username.indexOf('..') !== -1) {
      return null;
    }
    var expected = 'https://www.instagram.com/' + username + '/';
    var supplied = String(meta.creator_url || '');
    try {
      var parsed = new URL(supplied);
      var host = parsed.hostname.toLowerCase().replace(/^www\./, '');
      var segments = parsed.pathname.split('/').filter(Boolean);
      if (
        parsed.protocol === 'https:' &&
        host === 'instagram.com' &&
        segments.length === 1 &&
        decodeURIComponent(segments[0]).toLowerCase() === username &&
        !parsed.search &&
        !parsed.hash
      ) {
        return { handle: '@' + username, url: expected };
      }
    } catch (error) {
      /* The native contract falls back to the validated handle URL. */
    }
    return { handle: '@' + username, url: expected };
  }

  function hydrateStyleCreators(rows) {
    var mount = document.querySelector('[data-gettmi-style-creators]');
    if (!mount) return;
    var seen = {};
    var creators = surfaceRows(rows, 'style-discs').map(instagramCreator).filter(function (creator) {
      if (!creator || seen[creator.handle]) return false;
      seen[creator.handle] = true;
      return true;
    });
    if (!creators.length) return;
    mount.replaceChildren(document.createTextNode('Featured creators: '));
    creators.forEach(function (creator, index) {
      var link = document.createElement('a');
      link.href = creator.url;
      link.target = '_blank';
      link.rel = 'noopener';
      link.textContent = creator.handle;
      mount.appendChild(link);
      if (index < creators.length - 1) mount.appendChild(document.createTextNode(' | '));
    });
  }

  function setTmiText(mount, selector, value) {
    var node = mount.querySelector(selector);
    if (node && value) node.textContent = String(value);
  }

  function safeTmiPath(path, fallback) {
    var value = String(path || fallback || '');
    return value.indexOf('/') === 0 ? value : fallback;
  }

  function safeExternalUrl(path, fallback) {
    var value = String(path || '');
    return /^https:\/\/[^ ]+$/i.test(value) ? value : fallback;
  }

  function hydrateTmi(cfg, rows) {
    var mount = document.querySelector('[data-gettmi-tmi-story]');
    var tmi = surfaceRows(rows, 'tmi')[0];
    if (!mount || !tmi) return;
    var meta = tmi.metadata || {};
    var contentWidth = mobileContentWidth();
    var heroTargetWidth = Math.max(1, contentWidth - 144);
    var creatorUrl = safeExternalUrl(
      meta.creator_url || tmi.link_path,
      'https://www.instagram.com/sheeeeoo/?hl=en'
    );
    var creator = mount.querySelector('[data-gettmi-tmi-creator]');
    var credit = mount.querySelector('[data-gettmi-tmi-credit]');
    var hero = document.createElement('img');
    hero.src = publicUrl(cfg, tmi, 900, 72, sourceHeightForTarget(900, heroTargetWidth, 347));
    hero.alt = meta.creator_name || tmi.title || 'Featured creator';
    hero.loading = 'lazy';
    creator.replaceChildren(hero);
    creator.href = creatorUrl;
    creator.setAttribute('aria-label', 'Open ' + (meta.credit_label || 'featured creator') + ' on Instagram');
    creator.classList.remove('gettmi-placeholder');
    credit.href = creatorUrl;
    credit.textContent = meta.credit_label || 'Featured Creator: @Sheeeeoo';

    setTmiText(mount, '[data-gettmi-tmi-icon-number]', meta.creative_icon_number || '#001');
    setTmiText(mount, '[data-gettmi-tmi-name]', meta.creator_name || tmi.title || 'SHEEEEOO');
    setTmiText(
      mount,
      '[data-gettmi-tmi-vibes]',
      Array.isArray(meta.vibe_lines) && meta.vibe_lines.length
        ? meta.vibe_lines.join('\n')
        : 'Romantic.\nPolished.\nDangerous.'
    );
    setTmiText(
      mount,
      '[data-gettmi-tmi-saving]',
      meta.saving_copy || 'A sharp heel, a tiny bag, and one ridiculous dress that does all the talking.'
    );
    setTmiText(mount, '[data-gettmi-tmi-collage-heading]', meta.collage_heading || 'What she’s into');
    setTmiText(mount, '[data-gettmi-tmi-quote]', meta.quote || 'Wear the thing they ask about.');

    var body = mount.querySelector('[data-gettmi-tmi-body]');
    if (body && Array.isArray(meta.body_paragraphs) && meta.body_paragraphs.length) {
      body.replaceChildren();
      meta.body_paragraphs.forEach(function (copy) {
        var paragraph = document.createElement('p');
        paragraph.textContent = copy;
        body.appendChild(paragraph);
      });
    }

    var ctaPath = safeTmiPath(meta.cta_path, '/collections/her-edit');
    var cta = mount.querySelector('[data-gettmi-tmi-cta]');
    cta.href = encodeURI(ctaPath);
    cta.textContent = (meta.cta_label || 'Shop #HerEdit and GETTMI') + ' →';
    var labels = Array.isArray(meta.collage_labels) && meta.collage_labels.length
      ? meta.collage_labels
      : ['The outfit', 'The mood', 'The brand', 'The save'];
    var collageWidth = Math.max(1, contentWidth - 24);
    var collageTargets = [
      { width: collageWidth * 0.56, height: 214 },
      { width: collageWidth * 0.41, height: 110 },
      { width: collageWidth * 0.49, height: 110 },
      { width: collageWidth * 0.48, height: 110 }
    ];
    surfaceRows(rows, 'tmi-collage').slice(0, 4).forEach(function (row, index) {
      var tile = mount.querySelector('[data-gettmi-tmi-collage="' + index + '"]');
      if (!tile) return;
      var label = row.title || row.metadata && row.metadata.label || labels[index] || 'T.M.I';
      var image = document.createElement('img');
      var target = collageTargets[index];
      image.src = publicUrl(cfg, row, 720, 72, sourceHeightForTarget(720, target.width, target.height));
      image.alt = label;
      image.loading = 'lazy';
      tile.prepend(image);
      tile.href = encodeURI(ctaPath);
      tile.setAttribute('aria-label', label);
      tile.querySelector('span').textContent = label;
      tile.classList.remove('gettmi-placeholder');
    });
  }

  function run() {
    var cfg = config();
    if (!cfg || !cfg.url || !cfg.key) return;
    window.fetch(
      cfg.url + '/rest/v1/home_campaign_images?select=id,surface,bucket,image_path,title,link_path,sort_order,metadata,updated_at',
      { headers: { apikey: cfg.key, Authorization: 'Bearer ' + cfg.key } }
    ).then(function (response) {
      if (!response.ok) return null;
      return response.json();
    }).then(function (rows) {
      if (!Array.isArray(rows)) return;
      hydrateStories(cfg, rows);
      hydrateEditorial(cfg, rows);
    }).catch(function () { /* placeholders remain; same failure mode as the app's fallback */ });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
